import { Palette } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";

const typography:
  | TypographyOptions
  | ((palette: Palette) => TypographyOptions) = {
  fontFamily: [
    "Catamaran",
    "sans-serif",
  ].join(","),
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 500,
  h1: {
    fontSize: 30,
    lineHeight: 1,
  },
  h2: {
    fontSize: 22,
    fontWeight: 400,
    lineHeight: 1,
  },
  h3: {
    fontSize: 20,
    fontWeight: 300,
    lineHeight: 1,
  },
  h4: {
    fontSize: 18,
    fontWeight: 300,
    lineHeight: 1,
  },
  h5: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.5,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  body1: {
    fontSize: "100%"
  },
  button: {
    textTransform: "none",
  },
};

export default typography;
